module.exports = __webpack_public_path__ + "media/bootstrap-icons/calendar-month-fill-b35af7bb.svg";